import React from 'react';
import PropTypes from 'prop-types';
import { getDisputeStageDetails } from './configStructure.js';
import './TimelineStageCard.scss';
function openStageData() {
    //TODO: openDrawer code will be written here
  }
const TimelineStageCard = (props) => {
    const openDrawer = (masterId,id, stageId) => {
        props.getApiDrawerData(masterId, id, stageId);
        props.toggleDrawer(true,id);
      };
    
    const getStageNames = getDisputeStageDetails(props.listItem.eventHeaderDetails.eventCode);
    
    return (<div className = "timeline-stage-card">
     
       <span className="timeline-stage-card-headline">{getStageNames.eventName}</span>  
      
       <span className="timeline-stage-card-button">
            {!props.isMerchantUser && getStageNames !== undefined && getStageNames.buttonList.map((value, index) => {
              return <button onClick={()  =>{openDrawer(props.listItem.eventBodyDetails[0].fields[value.buttonKey],value.buttonID,props.listItem.caseStageId)}} key={index} className="button-view">{value.buttonName}</button>
            })}
        </span>
         
    </div>);

}
 
TimelineStageCard.propTypes = {
    listItem:PropTypes.array,
    openDrawer:PropTypes.func
};

TimelineStageCard.defaultProps = {
    listItem:[],
    openDrawer: () => { }
};

export default TimelineStageCard;